module.exports = __webpack_public_path__ + "0ab54153eeeca0ce03978cc463b257f7.woff2";